import React, { useContext, useEffect, useRef } from "react";
import { graphql } from "gatsby";
import Container from "../components/Container";
import Hero from "../components/Hero";
import MDX from "../components/MDX";
import Preview from "../components/Preview";
import SEO from "../components/SEO";
import ProgressIndicator from "../components/ProgressIndicator";
import OptionsContext from "../components/OptionsContext";

const PostTemplate = ({ pageContext }) => {
  const next = pageContext.previous;
  const previous = pageContext.next;
  const options = useContext(OptionsContext);
  const speakerDeckRef = useRef(null);

  let ogImage;

  const { data } = pageContext;

  try {
    ogImage = data.image.cover;
  } catch (error) {
    ogImage = null;
  }

  useEffect(() => {
    const { speakerDeck, speakerDeck2 } = data;
    if (speakerDeck2) {
      const script = document.createElement("script");
      script.src = "//speakerdeck.com/assets/embed.js";
      script.async = true;
      script.className = "speakerdeck-embed";
      script.setAttribute("data-id", speakerDeck2);
      script.setAttribute("data-ratio", "1.77777777777778");
      speakerDeckRef.current.appendChild(script);
    }
    if (speakerDeck) {
      const script = document.createElement("script");
      script.src = "//speakerdeck.com/assets/embed.js";
      script.async = true;
      script.className = "speakerdeck-embed";
      script.setAttribute("data-id", speakerDeck);
      script.setAttribute("data-ratio", "1.77777777777778");
      speakerDeckRef.current.appendChild(script);
    }
  }, []);

  return (
    <>
      <SEO title={data.title} description={data.description} image={ogImage} />
      {options.progressIndicator && <ProgressIndicator />}
      <Container>
        <Hero
          title={data.title}
          image={data.image.url}
          date={data.createdAt}
          tags={data.tags}
          context={pageContext}
        />
        {data.content && <MDX content={data.content.html} />}
        <div ref={speakerDeckRef} style={{ maxWidth: 800, margin: "0 auto" }} />
        <Preview previous={previous} next={next} context={pageContext} />
      </Container>
    </>
  );
};

export default PostTemplate;
